import { previewOptions, PreviewType } from '@/utils/helpers';
import { SelectButton, SelectButtonProps } from 'primereact/selectbutton';
import React, { useEffect } from 'react';
import styled from 'styled-components';

const StyledSelectButton = styled(SelectButton)`
  &.p-selectbutton {
    width: max-content;
    border-radius: var(--default-border-radius);
    background-color: var(--beige-main);
    padding: var(--xxsmall-padding);
    height: var(--default-input-height);

    .p-button {
      padding: 10px;
      height: 42px;
      width: 42px;
      border-radius: 50%;
      border: none;
      background-color: var(--beige-main);
      color: var(--black-main);
      i {
        margin: auto;
      }

      &.p-highlight {
        background-color: var(--white-main);
      }
      &:focus,
      &:hover {
        box-shadow: none;
        color: var(--red-main);
      }
    }
  }
`;

export type SelectPreviewOption<T extends string> = {
  icon: string | React.ReactNode;
  value: T;
  label?: string;
};

type AppSelectPreviewTypePropsType<T extends string> = {
  tableName?: string;
  options?: SelectPreviewOption<T>[];
  optionLabel?: string;
  selectedPreviewType: T;
  setSelectedPreviewType: (previewType: T) => void;
  userId?: string;
  accountId?: string;
} & Omit<
  SelectButtonProps,
  | 'value'
  | 'options'
  | 'optionLabel'
  | 'onChange'
  | 'itemTemplate'
  | 'unselectable'
>;

export const AppSelectPreviewType = <T extends string = PreviewType>({
  tableName,
  options,
  optionLabel = 'value',
  selectedPreviewType,
  setSelectedPreviewType,
  userId,
  accountId,
}: AppSelectPreviewTypePropsType<T>) => {
  const previewTypeOptions = (options ??
    previewOptions) as SelectPreviewOption<T>[];
  const storageKey = `${tableName}-selectedPreviewType-${userId}-${accountId}`;

  useEffect(() => {
    if (!tableName) return;

    const typeFromLocalSt = localStorage.getItem(storageKey);
    const preselectedPreviewType = previewTypeOptions.some(
      (option) => option.value === typeFromLocalSt,
    )
      ? (typeFromLocalSt as T)
      : selectedPreviewType;
    setSelectedPreviewType(preselectedPreviewType);
  }, []);

  const handleSelectedPreviewTypeChange = (type: T) => {
    if (tableName) {
      localStorage.setItem(storageKey, type);
    }
    setSelectedPreviewType(type);
  };

  const justifyTemplate = (option: SelectPreviewOption<T>) =>
    typeof option.icon === 'string' ? (
      <i className={option.icon}></i>
    ) : (
      <>{option.icon}</>
    );
  return (
    <StyledSelectButton
      value={selectedPreviewType}
      onChange={(e) => handleSelectedPreviewTypeChange(e.value)}
      options={previewTypeOptions}
      optionLabel={optionLabel}
      itemTemplate={justifyTemplate}
      unselectable={false}
    />
  );
};
